<template>
  <a-spin style="margin-top:260px;" tip="登录中，请稍后...">
  </a-spin>
</template>

<script>
// import { oneValues } from '@/utils/util'

export default {
  created () {
    this.$router.push('/home')
    // if (oneValues().token) { // 个人中心来开放平台登录
    // }
  }
}
</script>

<style lang="less" scoped>

</style>
